// eslint-no-undef
import React from 'react';
import '../App.css';
import Footer from './Footer';
import Convo from './Convo';

export default class Conversations extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  showProfile(e, user) {
    if (e.target.id === 'user') {
      e.preventDefault();
      this.props.app.hideStuff(e);
      this.props.app.setState({profile: user, post: ''});
    }
  }

  componentDidMount() {
    let that = this;
    window.removeEventListener('scroll', (e) => that.handleScroll(e));
    this._conversationDiv.addEventListener('scroll', (e) => that.handleScroll(e));
  }

  handleScroll(e) {
    if (!e.target) return;
    if ((e.target.clientHeight + e.target.scrollTop) >= e.target.scrollHeight) {
      this.props.doConversationGet(this.props.neighbor);
    }
  }

  search(e) {
    if (e) e.preventDefault();
    this.props.app.setVisible({showSearchResults: true, searching: true, showConversations: true, showMessageViewer: false,
                               searchType: 'message', searchString: this.state.searchString});
  }

  render() {
    let conversations = this.props.conversations;
    let actualConversations = [];

    for (let i = 0; i < conversations.length; i++) {
      let conversation = this.props.conversations[i];
      let hasUnread = conversation['unreadMessage'] || conversation['has_unread'] || ''
      let avatar = undefined;
      let titleUsers = [];
      for (let i = 0; i < conversation['users'].length; i++) {
        let cuser = conversation['users'][i];
        if (typeof cuser === 'string') {
          if (cuser !== this.props.user.username) {
            avatar = cuser.avatar;
            titleUsers.push(cuser);
          }
        } else {
          if (cuser['username'] !== this.props.user.username) {
            if (conversation['users'].length === 2) {
              avatar = cuser.avatar;
            }
            titleUsers.push(cuser['username']);
          }
        }
      }
      let selected = false;
      if (this.props.selectedConversation && this.props.selectedConversation._id.$oid === conversation['_id']['$oid']) {
        selected = true;
      }
      let conv = <Convo key={conversation['_id']['$oid']} unreadMessage={hasUnread} avatar={avatar} conversation={conversation}
                        selected={selected} title={conversation['title']} app={this.props.app} current_user={this.props.user}
                        selectConversation={(oid) => this.props.selectConversation(oid)}
                  />;
      actualConversations.push(conv);
    }
    return (
      <div className='conversationsDiv'>
        <div className='genericLabel'>&nbsp; Conversas</div>
        <div className='mediumInput'>
          <form onSubmit={(e) => this.search(e)}>
            <input className='message_search' placeholder='Pesquisa' type='text' onChange={(e) => this.setState({searchString: e.target.value})}
                   value={this.state.searchString || ''} />
          </form>
        </div>
        <hr style={{width: '100%', marginBottom: '0px'}} />
        <div className='conversationsInterior' ref={(ref) => this._conversationDiv = ref}>
          {actualConversations || ''}
        </div>
        <Footer />
      </div>
    );
  }
}
